export const AskType = {
  VIDEO: 15,
  IMAGE: 14
}

export const originList = [
  {
    label: '小程序患者预约',
    value: 1
  },
  {
    label: '线下门店预约',
    value: 2
  },
  {
    label: '健康管家代预约',
    value: 3
  },
]

export const askStatusList = [
  {
    label: '待问诊',
    value: 0
  },
  {
    label: '问诊中',
    value: 1
  },
  {
    label: '已完成',
    value: 2
  },
  {
    label: '已取消',
    value: 7
  },
  {
    label: '已过期',
    value: 8
  },
]

// 问诊预约状态
export const AskReservationStatus = {
	// // 挂号待支付
	// REGISTERPAY: 0,
	// // 待问诊
	// AWAIT: 1,
	// // 问诊中
	// ASKING: 2,
	// // 已超时
	// TIMEOUT: 3,
	// // 待支付
	// PAY: 4,
	// // 待发货
	// DELIVERY: 5,
	// // 待收货
	// RECEIVE: 6,
	// // 已完成
	// SUCCESS: 7,
	// // 已取消
	// CANCEL: 8,
	// // 待自取
	// PICKUP: 9,
	// // 已退货
	// RETURNED: 10,
	// // 已过期
	// INVALID: 11


	// 挂号待支付
	REGISTERPAY: 3,
	// 待问诊
	AWAIT: 0,
	// 问诊中
	ASKING: 1,
	// 已完成
	SUCCESS: 2,
	// 已退货
	RETURNED: 4,
	// 已取消
	CANCEL: 7,
	// 已超时
	TIMEOUT: 8,
	// 待支付
	// PAY: 4,
	// 待发货
	// DELIVERY: 5,
	// 待收货
	// RECEIVE: 6,
	
	
	// 待自取
	// PICKUP: 9,
	
	// 已过期
	// INVALID: 11
}

// 问诊预约状态查询
export const askReservationStatusFind = (status) => {
	switch (status) {
		case AskReservationStatus.REGISTERPAY:
			return {
				label: '挂号待支付',
				color: '#5f6ef9'
			}
		case AskReservationStatus.AWAIT:
			return {
				label: '待问诊',
				color: '#fda22a'
			}
		case AskReservationStatus.ASKING:
			return {
				label: '问诊中',
				color: '#5f6ef9'
			}
		case AskReservationStatus.TIMEOUT:
			return {
				label: '已超时',
				color: '#999'
			}
		case AskReservationStatus.PAY:
			return {
				label: '待支付',
				color: '#5f6ef9'
			}
		case AskReservationStatus.CANCEL:
			return {
				label: '已取消',
				color: '#999'
			}
		case AskReservationStatus.INVALID:
			return {
				label: '已过期',
				color: '#999'
			}
		case AskReservationStatus.SUCCESS:
			return {
				label: '已完成',
				color: '#999'
			}
		case AskReservationStatus.RETURNED:
			return {
				label: '已退货',
				color: '#999'
			}
		default:
			return {
				label: '',
				color: '#999'
			}
	}
}